import { createAction, props } from '@ngrx/store';

export const loadProjects = createAction('[Projects] Load Projects', props<getAllProjectsType>());
export const loadProjectsSuccess = createAction('[Projects] Load Projects Success', props<{ projects: any }>());
export const selectProject = createAction('[Projects] Select Project', props<any>());
export const selectProjectSuccess = createAction('[Projects] Select Project Success', props<any>());
export const addKWToProject = createAction('[Projects] add KW To Project', props<any>());
export const copyProject = createAction('[Projects] Copy Project');
export const removeProject = createAction('[Projects] Remove Project');
export const clearSelectProject = createAction('[Projects] Clear Select Project');
export const clearAllProjects = createAction('[Projects] Clear All Projects');
export const addSelectedPlan = createAction('[Plan] Add Plan', props<any>());
export const clearSelectedPlan = createAction('[Plan] Clear Plan');
export const planModified = createAction('[Projects] Remove Plan');
export const triggerStatics = createAction('[Panel] Trigger Statics');
export const triggerPanel = createAction('[Panel] Selected');
export const panelCountForPanelPage = createAction('[Panel] update Panel Count', props<any>());
export const resetPanelShowForPanelPage = createAction('[Panel] resetPanelShow for tools panel page', props<any>());
export const collapseIndexForPanelPage = createAction('[Panel] collapseIndex for tools panel page', props<any>());
export const detailsOfNonUsableAreas = createAction('[Panel] Non Usable Areas', props<any>());


export const PanelsDrawnAtInvStrings = createAction('[Inverter Panel] Panels Drawn', props<any>());
export const getAllInverters = createAction('[Inverter] Get All', props<any>());
export const selectedInverterCom = createAction('[Inverter] Selected Combo', props<any>());
export const selectedInverterEdit = createAction('[Inverter] Selected Edit', props<any>());
export const clearInverterEdit = createAction('[Inverter] Clear Selected Edit');

export interface getAllProjectsType {
    cmd: string,
    page: number,
    name?: string
}

export interface getAllProjectsSuccessType {
    name: string,
    updated: number,
    id: number
}

export interface getProjectType {
    cmd: string,
    id: number
}
